<div class="px-2" style="max-height: 84vh; min-height: 84vh; overflow-y: auto; overflow-x: hidden; background-color: #fff;" id="thumbs-container">
    <app-dataview [mediaParam]="mediaParam" [dataviewContent]="medias" (lazyEvent)="loadList($event)" [totalRecords]="recordsFiltered"
                  [sortOptions]="sortOptions" (searchEvent)="loadListWithSearch($event)"
                  (tagRemoved)="loadList(currentDatatableFilters)" (tagFiltered)="addFilterTagFromThumb($event)"
                  (addCart)="addToCart($event)" (removeCart)="removeFromCart($event.id)" (thumbUpdateEvent)="removeAndReload($event)" (deleted)="onDeleteMedia($event)"
                  [buttons]="buttons" type="dam" [cartLength]="cart.length" [cartIds]="cartIds" [filters]="allFilters" [searchByTag]="false"
                  (filterExpireMedia)="changeHideExpireMedia($event)"
                  (massTagStart)="massTagSelection($event)" (massTagEnd)="loadList(currentDatatableFilters)" [first]="currentDatatableFilters.first ? currentDatatableFilters.first : 0">
        <!-- En-tête (titre + sous-titre + panier) fusionné avec la barre de filtres : projeté en haut du header dataview, séparé par un hr. -->
        <div dataviewHeader>
            <div class="d-flex flex-wrap justify-content-between align-items-start" style="gap: .75rem;">
                <div class="mr-auto">
                    <h3 class="text-primary font-weight-bold mb-1">{{ 'general.listOf' | translate }} {{ "dam.mediaNumberTotal" | translate }}</h3>
                    <p class="text-muted mb-0">{{ "dam.listSubtitle" | translate }}</p>
                </div>
                <button (click)="openCart = !openCart" id="cartHeader" class="btn btn-outline-primary position-relative"
                        data-toggle="modal" data-target="#cartModal">
                    <fa-icon [icon]="faCart" class="mr-1"></fa-icon>{{ "dam.cartButton" | translate }}
                    <span *ngIf="cart.length > 0"
                          class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">{{ cart.length }}</span>
                </button>
            </div>
            <div class="mt-2" *ngIf="filterOptions.length > 0">
                <div class="d-flex flex-wrap align-items-center">
                    <div class="btn-group mr-1 mb-1" role="group" *ngFor="let filterOption of filterOptions">
                        <button class="btn btn-primary btn-sm" type="button" (click)="removeFilterOption(filterOption.name)">
                            <fa-icon [icon]="faTimes"></fa-icon>
                        </button>
                        <button class="btn btn-primary btn-sm" style="cursor: default;" type="button" disabled>
                            <span class="d-none d-md-inline-block">{{ 'filter.' + filterOption.type | translate }} :&nbsp;</span>
                            <span>{{ filterOption.name }}</span>
                        </button>
                    </div>
                    <button class="btn btn-danger btn-sm mb-1 ml-auto" type="button" (click)="removeAllFilterOptions()">
                        <fa-icon [icon]="faTrash"></fa-icon>
                        <span class="d-none d-md-inline-block ml-1">{{ 'general.clear' | translate }}</span>
                    </button>
                </div>
            </div>
            <hr class="mt-3 mb-3"/>
        </div>
    </app-dataview>
</div>
<!-- Modal -->
<div class="modal fade" id="cartModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{ "dam.cartButton" | translate }}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <ul class="list-unstyled" style="max-height: 70vh;overflow-x: hidden!important;">
                    <li *ngFor="let media of cart" class="pb-2 pt-2">
                        <div class="row">
                            <img class="col-4" [src]="media.thumbPath ? damUrl+media.thumbPath : getMediaThumb(media.extension, media.thumb)"
                                 style="max-height: 5rem; object-fit: contain;" alt="cartImage">
                            <span [ngbTooltip]="media.name" class="col-6 text-truncate mt-3">{{ media.name }}</span>
                            <div class="col-2 mt-2">
                                <button (click)="removeFromCart(media.id)" class="ml-auto btn btn-sm-danger">
                                    <fa-icon [icon]="faTrash"></fa-icon>
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">{{
                        "general.close" | translate
                    }}
                </button>
                <button (click)="emptyCart()" class="btn btn-danger" data-dismiss="modal">{{
                        "dam.emptyCart" | translate
                    }}
                </button>
                <button (click)="downloadCart()" [disabled]="cart.length === 0" class="btn btn-primary">{{
                        "dam.download" | translate
                    }}
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Pop-up d'import de médias (réutilise app-uploader en mode modal), ouverte
     depuis le bouton « Importer » à la place de la navigation vers la page dédiée. -->
<ng-template #uploadModal let-modal>
    <div class="modal-header align-items-center">
        <h4 class="modal-title mb-0">{{ "breadcrumb.dam.upload" | translate }}</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-uploader [modal]="true" (uploaded)="onMediasUploaded()" (closeRequested)="modal.dismiss()"></app-uploader>
    </div>
</ng-template>
